import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
// PRIMEIRO de todos: configura o SDK para esta plataforma. Qualquer import
// abaixo pode tocar no REST ou no gateway, e os dois exigem a configuracao
// feita — ver packages/client-sdk/src/config.ts.
import './lib/sdk.js';
import { App } from './App.js';
import './index.css';

const root = document.getElementById('root');
if (!root) throw new Error('#root não encontrado');

createRoot(root).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
